import styled from "styled-components";

import { QUERIES, SPACING } from "../../../utils/constants";
import { Tone, TONE_COLORS } from "../styles";

export const SectionGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: ${SPACING.md}px;

  @media ${QUERIES.tabletLargeAndUp} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const HealthGrid = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: ${SPACING.sm}px;
  margin: 0;
  padding: 0;
  list-style: none;

  @media ${QUERIES.tabletLargeAndUp} {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: ${SPACING.md}px;
  }
`;

export const Cell = styled.li`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xs}px;
  padding: ${SPACING.md}px;
  border: 1px solid var(--color-card-metric-border);
  border-radius: 12px;
  background: var(--color-card-metric-background);
`;

export const CellLabel = styled.span`
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
`;

export const CellValue = styled.span`
  display: flex;
  align-items: baseline;
  gap: ${SPACING.sm}px;
  font-size: var(--text-base);
  font-weight: 600;
  color: var(--color-text-default);
`;

export const StatusDot = styled.span<{ $tone: Tone }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
  background: ${({ $tone }) => TONE_COLORS[$tone].color};
`;

export const AttentionRows = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const AttentionRowItem = styled.li`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: start;
  gap: ${SPACING.xs}px ${SPACING.sm}px;
  padding: ${SPACING.sm}px 0;
  border-top: 1px solid var(--color-border);
  font-size: var(--text-base);

  &:first-child {
    border-top: none;
  }

  > :nth-child(n + 3) {
    grid-column: 2;
  }

  @media ${QUERIES.tabletLargeAndUp} {
    grid-template-columns: auto minmax(0, 2fr) minmax(0, 3fr) minmax(0, 1fr);
    gap: ${SPACING.md}px;

    > :nth-child(n + 3) {
      grid-column: auto;
    }
  }
`;

export const SeverityIcon = styled.span<{ $tone: Tone }>`
  display: inline-flex;
  color: ${({ $tone }) => TONE_COLORS[$tone].color};
`;

export const TitleLine = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.sm}px;
  flex-wrap: wrap;
`;

export const AttentionTitle = styled.span`
  font-weight: 600;
`;

export const AttentionContext = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xxs}px;
  color: var(--color-text-secondary);
`;

export const EmptyAttention = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${SPACING.xs}px;
  padding: ${SPACING.lg}px;
  font-size: var(--text-base);
  text-align: center;
`;

export const QueueGroupBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.sm}px;
`;

export const QueueGroupTitle = styled.h3`
  margin: 0;
  font-size: var(--text-base);
`;

export const BarTrack = styled.div`
  display: flex;
  height: 14px;
  overflow: hidden;
  border-radius: 7px;
  background: var(--color-background-3);
`;

export const BarSegment = styled.div<{ $count: number; $color: string }>`
  flex: ${({ $count }) => $count} 1 0;
  background: ${({ $color }) => $color};
`;

export const Legend = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: ${SPACING.xs}px ${SPACING.md}px;
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: var(--text-base);
`;

export const LegendItem = styled.li`
  display: flex;
  align-items: center;
  gap: ${SPACING.sm}px;
`;

export const Swatch = styled.span<{ $color: string }>`
  width: 10px;
  height: 10px;
  border-radius: 2px;
  background: ${({ $color }) => $color};
  flex-shrink: 0;
`;

export const SchedulerRow = styled.li`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: ${SPACING.xs}px ${SPACING.md}px;
  padding: ${SPACING.sm}px 0;
  border-top: 1px solid var(--color-border);
  font-size: var(--text-base);

  &:first-child {
    border-top: none;
  }
`;

export const SchedulerList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const SchedulerName = styled.span`
  font-weight: 600;
`;

export const SchedulerFooter = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: ${SPACING.xs}px ${SPACING.md}px;
  flex-wrap: wrap;
  font-size: var(--text-base);
`;
